import React from 'react';
import Image from './Image';
import Price from './Price';
import { useSelector } from 'react-redux';
import constants from '../app/constants';

/**
 *
 * @param props.productName
 * @param props.totalDiscount
 * @param props.totalPrice
 * @param props.isInsuranceEnabled
 * @param props.isInsuranceLoading
 * @param props.handleBackClick
 * @param props.handleOpenExit
 */

const MainHeader = props => {
    const labels = useSelector(state => state.main.labels);
    const baseURLs = useSelector(state => state.main.baseURLs);
    const currentStep = useSelector(state => state.main.currentStep);
    const firstStep = useSelector(state => state.main.firstStep);
    const isLearnMoreModalOpen = useSelector(state => state.main.isLearnMoreModalOpen);
    const isPrescriptionModalOpen = useSelector(state => state.main.isPrescriptionModalOpen);
    const isPupillaryDistanceModalOpen = useSelector(state => state.main.isPDModalOpen);

    const isAnyModalOpen =
        isLearnMoreModalOpen || isPrescriptionModalOpen || isPupillaryDistanceModalOpen;

    const getProgressBarValue = () => {
        return (currentStep + 1) * (100.0 / constants.steps.length);
    };

    return (
        <div className="main-header">
            <input aria-label="Configurator start" id="rxc-wcag-start" type="checkbox" />
            <div id="rxc-main-header" className="main-header-content">
                {props.config && props.config.brand !== 'costa' && (
                    <a
                        className={'header-back' + (currentStep == firstStep ? ' invisible' : '')}
                        aria-label="Go to previous step"
                        href="#"
                        onClick={props.handleBackClick}
                        dataElementId={
                            'X_X_LensPanel_' + labels.stepAnalyticsName[currentStep] + '-Back'
                        }
                        dataDescription={labels.stepAnalyticsName[currentStep - 1]}
                    >
                        Back
                    </a>
                )}
                <div className="header-left-content">
                    <a
                        tabIndex={isAnyModalOpen ? '-1' : '0'}
                        href="#"
                        onClick={props.handleOpenExit}
                    >
                        <div className="header-logo"></div>
                    </a>
                    <div className="header-product-name">{props.productName}</div>
                </div>
                <div className="header-right-content">
                    {props.config.insuranceModule ? (
                        <div className="header-insurance">
                            <a
                                href="#"
                                className={
                                    'lc-link insurance-label' +
                                    (props.isInsuranceEnabled ? ' active' : ' ')
                                }
                                aria-label="Add or remove insurance benefits"
                                data-element-id={
                                    'X_X_LensPanel_' +
                                    labels.stepAnalyticsName[currentStep] +
                                    '-UseInsurance'
                                }
                                onClick={props.handleAddInsurance}
                                tabIndex={isAnyModalOpen ? '-1' : '0'}
                            >
                                <Image
                                    imageClass={
                                        'insurance-image' +
                                        (props.isInsuranceEnabled ? ' active' : ' ')
                                    }
                                    url={
                                        props.isInsuranceEnabled
                                            ? constants.baseURLs.genericImage
                                            : props.config.brand === 'opsm'
                                            ? baseURLs.genericImage
                                            : baseURLs.projectImage
                                    }
                                    //insurance-yellow-shape mancante
                                    fileName={
                                        !props.isInsuranceEnabled
                                            ? 'insurance-blue-shape'
                                            : props.config.brand === 'glasses'
                                            ? 'insurance-yellow-shape'
                                            : 'global_green_tick'
                                    }
                                    alt="insurance image"
                                />
                                {props.isInsuranceEnabled
                                    ? labels.insurance.copy.active
                                    : labels.insurance.copy.inactive}
                            </a>
                        </div>
                    ) : null}
                    <div className="header-price">
                        <Price
                            value={props.totalPrice}
                            discount={props.totalDiscount}
                            isInsuranceEnabled={currentStep > 2 && props.isInsuranceEnabled}
                            isInsuranceLoading={props.isInsuranceLoading}
                            isHeaderPrice={true}
                            label={
                                currentStep == constants.steps.length - 1 ||
                                currentStep == constants.steps.length - 2
                                    ? labels.price.frameLens
                                    : labels.price.frame
                            }
                        />
                    </div>
                </div>
                <a
                    className="header-exit"
                    aria-label="Close lens selector"
                    href="#"
                    onClick={props.handleOpenExit}
                >
                    Close
                </a>
            </div>
            <div className="header-progressbar-container">
                <div
                    className="header-progressbar"
                    style={{ width: getProgressBarValue() + '%' }}
                />
            </div>
        </div>
    );
};

export default MainHeader;
